<template>
  <div>
    <div
      style="
        width: 760px;
        margin-bottom: 20px;
        margin-top: 25px;
        position: relative;
      "
      class="lk_content_info_block"
    >
      <div style="display: table-cell; width: 70px">
        <el-icon
          style="
            font-size: 50px;
            position: absolute;
            transform: rotate(180deg);
            left: 20px;
            color: #e82862;
          "
          ><Warning
        /></el-icon>
      </div>
      <div style="display: table-cell">
        <br />
        <span v-if="store.langSelect.value == 0">
          Для обмена выберите криптовалюту которую отдаете (слева) и задайте
          количество. Справа выберите криптовалюту которую получите и проверьте
          расчет количества.
        </span>
        <span v-else>
          To exchange, select the cryptocurrency you are giving away (on the
          left) and set the amount. On the right, select the cryptocurrency you
          will receive and check the calculation of the amount.</span
        >
        <br /><br />
      </div>
    </div>
    <div class="table" style="height: 252px; width: 700px">
      <div
        class="col"
        style="background-color: #f7f7f7; width: 359px; height: 252px"
      >
        <div style="padding-top: 25px; padding-left: 24px">
          <div style="margin-bottom: 20px">
            <div class="mylabel">
              {{ messages.account[store.langSelect.value] }}:
            </div>
            <div style="margin-top: 6px">
              <div class="myselector" style="width: 179px">
                <el-select
                  v-model="inAccount"
                  icon-сlass="caret-top"
                  placeholder="Select"
                >
                  <el-option
                    v-for="(item, i) in accounts"
                    :key="i"
                    :label="item.Account"
                    :value="item.Account"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="margin-bottom: 20px; height: 64px">
            <div style="float: left">
              <div class="mylabel">
                {{ messages.currency[store.langSelect.value] }}:
              </div>
              <div style="margin-top: 6px">
                <div class="myselector" style="width: 142px">
                  <el-select
                    v-model="inCurrency"
                    icon-сlass="caret-top"
                    placeholder="Select"
                  >
                    <el-option
                      v-for="(item, i) in currency"
                      :key="i"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div style="float: left">
              <div class="mylabel">
                {{ messages.amount[store.langSelect.value] }}:
              </div>
              <div style="margin-top: 6px">
                <div class="myinput" style="width: 142px">
                  <div>
                    <div>
                      <input
                        class="my-input__inner"
                        type="text"
                        style="text-align: right"
                        autocomplete="off"
                        v-model="inValue"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="float: left; margin: 32px 0 0 10px">
              <!--  <span class="all">{{messages.all[store.langSelect.value]}}</span> -->
            </div>
          </div>

          <div>
            <div style="float: left; width: 142px">
              <div class="mylabel">
                {{ messages.thereis[store.langSelect.value] }}:
              </div>
              <div style="margin-top: 6px">
                <div>
                  <div class="mylabel">
                    <span
                      v-if="inInstrument != null"
                      v-text="inInstrument.Shares"
                    ></span>
                    <span v-else>0.00</span>
                  </div>
                </div>
              </div>
            </div>
            <div style="float: left; width: 112px">
              <div class="mylabel">
                {{ messages.willbe[store.langSelect.value] }}:
              </div>
              <div style="margin-top: 6px">
                <div>
                  <div class="mylabel">
                    <span
                      v-if="inInstrument != null && inCurrency != outCurrency"
                      v-text="inInstrument.Shares - inValue * 1"
                    ></span>
                    <span
                      v-if="
                        inInstrument != null &&
                        inAccount == outAccount &&
                        inCurrency == outCurrency
                      "
                      v-text="inInstrument.Shares"
                    ></span>
                    <span v-if="inInstrument == null">0.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col" style="width: 82px; position: relative">
        <div style="position: absolute; left: 27px; top: 115px">
          <svg
            width="30"
            height="20"
            viewBox="0 0 30 2"
            preserveAspectRatio="xMidYMid meet"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1H29"
              stroke="#D4D9DD"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <svg
            width="10"
            height="20"
            viewBox="0 0 10 18"
            style="margin-left: -10px"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L9 9L1 17"
              stroke="#D4D9DD"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div
        class="col"
        style="background-color: #f7f7f7; width: 359px; height: 252px"
      >
        <div style="padding-top: 25px; padding-left: 24px">
          <div style="margin-bottom: 20px">
            <div class="mylabel">
              {{ messages.account[store.langSelect.value] }}:
            </div>
            <div style="margin-top: 6px">
              <div class="myselector" style="width: 179px">
                <el-select
                  v-model="outAccount"
                  icon-сlass="caret-top"
                  placeholder="Select"
                >
                  <el-option
                    v-for="(item, i) in accounts"
                    :key="i"
                    :label="item.Account"
                    :value="item.Account"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="margin-bottom: 20px; height: 64px">
            <div style="float: left">
              <div class="mylabel">
                {{ messages.currency[store.langSelect.value] }}:
              </div>
              <div style="margin-top: 6px">
                <div class="myselector" style="width: 142px">
                  <el-select
                    v-model="outCurrency"
                    icon-сlass="caret-top"
                    disabled="true"
                    placeholder="Select"
                  >
                    <el-option
                      v-for="(item, i) in currency"
                      :key="i"
                      :label="item.name"
                      :value="item.value"
                      disabled="true"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div style="float: left">
              <div class="mylabel">
                {{ messages.amount[store.langSelect.value] }}:
              </div>
              <div style="margin-top: 6px">
                <div class="myinput" style="width: 142px">
                  <div>
                    <div>
                      <input
                        class="my-input__inner"
                        type="text"
                        readonly=""
                        style="text-align: right"
                        autocomplete="off"
                        v-model="outValue"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="float: left; margin: 32px 0 0 10px">
              <!-- <span class="all">Всё</span> -->
            </div>
          </div>
          <div>
            <div style="float: left; width: 142px">
              <div class="mylabel">
                {{ messages.thereis[store.langSelect.value] }}:
              </div>
              <div style="margin-top: 6px">
                <div>
                  <div class="mylabel">
                    <span
                      v-if="outInstrument != null"
                      v-text="outInstrument.Shares"
                    ></span>
                    <span v-else>0.00</span>
                  </div>
                </div>
              </div>
            </div>
            <div style="float: left; width: 142px">
              <div class="mylabel">
                {{ messages.willbe[store.langSelect.value] }} :
              </div>
              <div style="margin-top: 6px">
                <div>
                  <div class="mylabel">
                    <span
                      v-if="outInstrument != null && outCurrency != inCurrency"
                      v-text="outInstrument.Shares + outValue * 1"
                    ></span>
                    <span
                      v-else-if="inCurrency != outCurrency"
                      v-text="outValue"
                    ></span>
                    <span
                      v-else-if="outInstrument != null"
                      v-text="outInstrument.Shares"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: 20px">
      <div style="display: inline-block; margin-left: 25px; width: 490px">
        <Button
          :text="messages.exchange2[store.langSelect.value]"
          v-show="!sended"
          @click="sendConversion"
        />
        <div v-show="sended">
          <h4>{{ messages.sended[store.langSelect.value] }}</h4>
          <Button text="Ok" @click="sended = false" />
        </div>
      </div>
      <div style="display: inline-block; text-align: right" class="currency">
        {{ messages.courseInfo[store.langSelect.value] }}
        <br />
        1BTC = {{ getLast.toFixed(2) }} USDT
        <br />
        {{ getStringTime(btcusdt.LastT) }} на UTC
      </div>
    </div>
    <div style="margin-top: 50px">
      <ServiceHistotyTable>
        <template v-slot:mtthead="">
          <div class="th">Date</div>
          <div class="th">Account</div>
          <div class="th">Currency</div>
          <div class="th">Value</div>
          <div class="th">To account</div>
          <div class="th">To currency</div>
        </template>
        <template v-slot:mttbody="props">
          <div class="tr" v-show="props.item.Service == 'exchange'">
            <div class="td">{{ getStringTime(props.item.Date) }}</div>
            <div class="td">{{ props.item.HistoryInfo.Account }}</div>
            <div class="td">{{ props.item.HistoryInfo.Currency }}</div>
            <div class="td">{{ props.item.HistoryInfo.Value }}</div>
            <div class="td">{{ props.item.HistoryInfo.AccountOut }}</div>
            <div class="td">{{ props.item.HistoryInfo.CurrencyOut }}</div>
          </div>
        </template>
      </ServiceHistotyTable>
      <!--<MoneyTransactionHistoryTable :account="inAccount" src="exchange">
        <template v-slot:mtthead="">
          <div class="th">Date</div>
          <div class="th" style="width: 500px">Description</div>
          <div class="th">To</div>
        </template>
        <template v-slot:mttbody="props">
          <div class="tr" v-if="props.item.src === 'exchange'">
            <div class="td">{{ getStringTime(props.item.m) }}</div>
            <div class="td">{{ props.item.desc }}</div>
            <div class="td">{{ props.item.crd }}</div>
          </div>
        </template>
      </MoneyTransactionHistoryTable> -->
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import { ref, watch } from "vue";
import { useMyStorage, getAccPositions } from "@/store/global";
//import MoneyTransactionHistoryTable from "./MoneyTransactionHistoryTable";
import ServiceHistotyTable from "./ServiceHistotyTable";
import axios from "axios";
import { Warning } from "@element-plus/icons-vue";
export default {
  name: "ConversionComponent",
  components: {
    //    MoneyTransactionHistoryTable,
    Button,
    ServiceHistotyTable,
    Warning,
  },
  setup() {
    const exchange = 0.4;
    const inAccount = ref("");
    const outAccount = ref("");
    const inCurrency = ref("");
    const outCurrency = ref("");
    const inValue = ref("0.00");
    const outValue = ref("0.00");
    const sharesIn = ref(0);
    const sharesOut = ref(0);
    const getLast = ref(0);
    const sended = ref(false);
    const store = useMyStorage();
    const accounts = store.userInfo.value.Info.Accounts;
    outAccount.value = inAccount.value = accounts[0].Account;
    let positionsInAccount = getAccPositions(inAccount.value);
    let positionsOutAccount = getAccPositions(outAccount.value);
    const instruments = store.getInstrumentsFull;
    const btcusdt = ref(instruments.value[store.calcTicker.value]);
    const inAccInfo = store.getAccPositions(inAccount.value);
    const outAccInfo = store.getAccPositions(outAccount.value);
    const inInstrument = ref("");
    const outInstrument = ref("");
    let setCurrency = false;
    const calculate = () => {
      if (inCurrency.value === outCurrency.value) {
        outValue.value = inValue.value;
      }
      if (btcusdt.value.Last !== undefined && btcusdt.value.Last !== 0) {
        if (
          inCurrency.value === currency[0].value &&
          outCurrency.value === currency[1].value
        ) {
          outValue.value =
            inValue.value *
            (btcusdt.value.Last - (btcusdt.value.Last / 100) * exchange);
        }
        if (
          inCurrency.value === currency[1].value &&
          outCurrency.value === currency[0].value
        ) {
          outValue.value =
            inValue.value /
            (btcusdt.value.Last + (btcusdt.value.Last / 100) * exchange);
        }
      }
    };
    watch(
      () => inAccount.value,
      () => {
        outAccount.value = inAccount.value;
        inValue.value = 0.0;
        outValue.value = 0.0;
        positionsInAccount = getAccPositions(inAccount.value);
        inInstrument.value = getInstrumentFromPosition(
          positionsInAccount,
          inCurrency.value
        );
        console.log(positionsInAccount);
      }
    );
    watch(
      () => outAccount.value,
      () => {
        inAccount.value = outAccount.value;
        inValue.value = 0.0;
        outValue.value = 0.0;
        positionsOutAccount = getAccPositions(outAccount.value);
        outInstrument.value = getInstrumentFromPosition(
          positionsOutAccount,
          outCurrency.value
        );
      }
    );
    watch(
      () => inCurrency.value,
      () => {
        if (setCurrency !== true) {
          setCurrency = true;
          inValue.value = "0.0";
          const v = instruments.value[store.calcTicker.value].Last;
          if (inCurrency.value === "BTC") {
            getLast.value = v * ((100 - exchange) / 100);
            if (inAccount.value === outAccount.value) {
              outCurrency.value = currency[1].value;
            }
          }
          if (inCurrency.value === "USDT") {
            getLast.value = v * ((100 + exchange) / 100);
            if (inAccount.value === outAccount.value) {
              outCurrency.value = currency[0].value;
            }
          }
          setCurrency = false;
        }
      }
    );
    watch(
      () => inValue.value,
      () => {
        if (inValue.value * 1 > inInstrument.value.Shares * 1) {
          inValue.value = inInstrument.value.Shares.toString();
          calculate();
        }
      }
    );
    watch(
      () => inInstrument.value.Shares,
      () => {
        if (inValue.value * 1 > inInstrument.value.Shares * 1) {
          inValue.value = inInstrument.value.Shares.toString();
          calculate();
        }
      }
    );
    watch(
      () => instruments.value[store.calcTicker.value].Last,
      (v) => {
        if (inCurrency.value === "BTC") {
          getLast.value = v * ((100 - exchange) / 100);
        }
        if (inCurrency.value === "USDT") {
          getLast.value = v * ((100 + exchange) / 100);
        }
        btcusdt.value = instruments.value[store.calcTicker.value];
        calculate();
      }
    );
    const getStringTime = (val) => {
        const ts= new Date(val)
        return (
          ts.getUTCFullYear() +
          "-" +
          pad(ts.getUTCMonth() + 1) +
          "-" +
          pad(ts.getUTCDate()) +
          " " +
          pad(ts.getUTCHours()) +
          ":" +
          pad(ts.getUTCMinutes()) +
          ":" +
          pad(ts.getUTCSeconds())
        );

    };
    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    };

    const sendConversion = () => {
      console.log(inValue.value * 1);
      if (inValue.value * 1 > 0.00000000001) {
        /*type ExchangeMail struct {
	Account string
	Currency string
	AccountOut string
	CurrencyOut string
	Value string

}*/
        let data = {
          Account: inAccount.value,
          Currency: inCurrency.value,
          AccountOut: outAccount.value,
          CurrencyOut: outCurrency.value,
          Value: inValue.value,
          ValueOut: outValue.value.toString(),
        };
        const url = store.ServerUrl + "/users/sendexchange";
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + store.token.value;
        axios.post(url, data);

        let info =
          "{'service':'Exchange', 'Account':'" +
          inAccount.value +
          "', 'Value':'" +
          inValue.value +
          "', 'Currency':'" +
          inCurrency.value +
          "', 'AccountOut':'" +
          outAccount.value +
          "', 'CurrencyOut':'" +
          outCurrency.value +
          "', 'ValueOut':'" +
          outValue.value +
          "', 'Last':'" +
          btcusdt.value.Last +
          "', 'Rate':'" +
          getLast.value +
          "'}";
        inValue.value = "0.00";
        sended.value = true;
        let shis = {
          service: "exchange",
          accounts: inAccount.value,
          email: store.userInfo.value.Roles.email,
          status: "pending",
          historyinfo: info,
        };
        axios
          .post(store.ServerUrl + "/users/savesevicehistory", shis)
          .finally(() => {
            store.LoadServiceHistory(inAccount.value);
          });
      }
      return null;
    };
    const getInstrumentFromPosition = (acc, ticker) => {
      if (acc !== undefined) {
        let v = null;
        acc.value.forEach((el) => {
          if (el.Ticker === ticker) {
            v = el;
          }
        });
        // console.log(v)
        return v;
      }
      return null;
    };
    const currency = [
      { value: "BTC", name: "BTC" },
      {
        value: "USDT",
        name: "USDT",
      },
    ];
    inCurrency.value = currency[0].value;
    outCurrency.value = currency[1].value;
    inInstrument.value = getInstrumentFromPosition(
      positionsInAccount,
      inCurrency.value
    );
    outInstrument.value = getInstrumentFromPosition(
      positionsOutAccount,
      outCurrency.value
    );

    watch(
      () => positionsInAccount,
      () => {
        //  console.log("inPos")
        inInstrument.value = getInstrumentFromPosition(
          positionsInAccount,
          inCurrency.value
        );
      },
      { deep: true }
    );
    watch(
      () => positionsOutAccount,
      () => {
        // console.log("outPos")
        outInstrument.value = getInstrumentFromPosition(
          positionsOutAccount,
          outCurrency.value
        );
      },
      { deep: true }
    );
    watch(
      () => inCurrency.value,
      () => {
        // console.log("incur")
        inInstrument.value = getInstrumentFromPosition(
          positionsInAccount,
          inCurrency.value
        );
        calculate();
        // console.log(inInstrument)
      }
    );
    watch(
      () => outCurrency.value,
      () => {
        // console.log("outcur")
        outInstrument.value = getInstrumentFromPosition(
          positionsOutAccount,
          outCurrency.value
        );
        calculate();
      }
    );
    watch(
      () => inValue.value,
      (v) => {
        console.log("--*******------", v);
        //  inValue.value=v*1.00
        if (v !== 0) {
          inValue.value = v.replace(",", ".");
        }
        calculate();
        console.log("--------", v);
      }
    );

    const messages = {
      account: ["Аккаунт", "Account"],
      exchange: ["Конвертация", "Exchange"],
      amount: ["Сумма", "Amount"],
      all: ["Все", "All"],
      thereis: ["Есть", "There is"],
      willbe: ["Будет ", "Will be"],
      exchange2: ["Обменять", "Exchange"],
      currency: ["Валюта", "Currency"],
      courseInfo: ["Индикативный курс обмена", "Indicative exchange rate"],
      sended: [
        "Заявка на обмен успешно отправлена. Обработка будет произведена в течении 30 минут.",
        "The exchange request has been successfully sent. Processing will be done within 30 minutes.",
      ],
      tableHead: ["История операций по", "History of transactions on account"],
    };
    return {
      sendConversion,
      inAccount,
      outAccount,
      outCurrency,
      inCurrency,
      store,
      accounts,
      currency,
      btcusdt,
      exchange,
      getStringTime,
      getLast,
      inValue,
      outValue,
      inAccInfo,
      outAccInfo,
      sharesIn,
      sharesOut,
      inInstrument,
      outInstrument,
      positionsInAccount,
      positionsOutAccount,
      messages,
      sended,
    };
  },
};
</script>
<style>
/*.el-input__inner {
  border-radius: 2px !important;
  border: 1px solid #C4C4C4 !important;
  box-sizing: border-box !important;
  height: 40px !important;
  outline: none !important;
  padding: 0 15px 0 15px !important;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1) !important;
  width: 100% !important;
  cursor: pointer !important;
  display: block !important;
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 17px !important;
  line-height: 20px !important;
  color: #222222 !important;
}

.el-input-number__decrease:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled), .el-input-number__increase:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled), .el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner {
  border-color: #c4c4c4 !important;
}

.el-select .el-input__inner:focus {
  border-color: #c4c4c4 !important;
}

.el-select-dropdown__item.selected {
  color: #e82862 !important;
  font-weight: 700 !important;
}

.el-select-dropdown__item {
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 17px !important;
  line-height: 20px !important;
  color: #222222 !important;
  padding: 5px 20px !important;
}

.el-select .el-input .el-select__caret {
  color: #222222 !important;
}*/
</style>
<style scoped>
div.currency {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #777777;
  text-align: right;
  width: 284px;
}

span.all {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 17px;
  color: #222222;
  text-decoration: underline;
}

.myselector,
.myinput {
  display: inline-block;
  position: relative;
  height: 40px;
}

.my-input__suffix {
  position: absolute;
  height: 100%;
  top: 17px;
  text-align: center;
  color: #c0c4cc;
  transition: all 0.3s;
  pointer-events: none;
}

.myselector .my-input__inner {
  padding-right: 30px;
}

.my-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  height: 32px;
  outline: none;
  padding: 0 15px 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  cursor: pointer;
  display: block;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
  color: #222222;
}

.mylabel {
  text-align: left;
  color: #777777;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
}

div.rotate.close {
  background-color: white;
  border: none;
  color: white;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: background 0s 0.3s;
  transform: rotate(45deg);
}

div.rotate {
  background-color: white;
  border: none;
  color: white;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: background 0s 0.3s;
}

div.rotate:focus {
  outline: none;
  border: none;
  background-color: white;
}

div.rotate span {
  position: absolute;
  display: block;
  left: 0px;
  bottom: 6px;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
}

div.rotate span::before {
  position: absolute;
  display: block;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
  transform: rotate(90deg);
}

.t_left {
  text-align: left !important;
}

.table {
  width: 100%;
  display: table;
  table-layout: fixed;
  /*min-height: 80px;*/
}

.cel,
.col {
  display: table-cell;
}

.vmiddle {
  vertical-align: middle;
}

.head {
  border-bottom: 1px solid #e82862;
  font-family: Proxima Nova Condensed;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 17px;
  color: #777777;
  width: 100%;
  padding-bottom: 4px;
  height: 17px;
}

.mytable {
  width: 100%;
  position: relative;
}

.head_info_rotate {
  position: absolute;
  left: -17px;
  top: 42px;
  padding: 0px;
  margin: 0px;
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
  width: 60px;
  text-align: right;
}

.head_closed {
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
  border-bottom: 1px solid #e82862;
  padding-bottom: 1px;
}

.account_info_small_top {
  margin-left: 3px;
  font-family: Proxima Nova Condensed;
  font-size: 10px;
  font-style: normal;
  font-weight: normal;
  line-height: 12px;
  color: #777777;
  position: absolute;
  display: inline-block;
}

.mytable_row {
  height: 20px;
}

.col .mytable_row:nth-child(even) {
  background-color: #f7f7f7;
}
</style>
